<messages>["./components/ClientCreateUpdate"]</messages>

<!--
================================================================================
  Template (HTML)
================================================================================
-->

<template>
  <base-layout mw1>
    <v-col cols="12">
      <client-create-update
        :is-create="false"
        :is-profile="true"
        :client-data="clientProfile"
        @unsavedChanges="setUnsavedChanges"
        @success="onSuccess"
        @cancel="back"/>
    </v-col>
  </base-layout>
</template>

<!--
================================================================================
  Logic (JavaScript)
================================================================================
-->

<script>
  import {mapActions, mapMutations} from 'vuex'

  import BaseLayout from '@/app/core/components/BaseLayout'
  import ClientCreateUpdate from './components/ClientCreateUpdate'

  import unsavedChangesHelper from '@/app/core/mixins/UnsavedChangesHelper'

  export default {
    name: 'ClientProfile',

    components: {
      BaseLayout,
      ClientCreateUpdate
    },

    mixins: [unsavedChangesHelper],

    data: () => ({
      clientProfile: {}
    }),

    created () {
      this.loadClientProfile ()
    },

    methods: {
      ...mapMutations ('notification', ['addEvent']),
      ...mapActions ('request', ['fetchData']),

      loadClientProfile () {
        return this.fetchData ({
          op: 'client/load',
          cb: data => {
            this.clientProfile = data.clientData
          }
        })
      },

      onSuccess (data) {
        this.addEvent ({
          type: 'success',
          message: this.$t ('saved.profile', {link: data.name}),
          objects: [{
            name: data.name,
            link: {name: 'client.view', params: {id: data.id}}
          }]
        })
        this.back ()
      },

      back () {
        this.$router.back ()
      }
    }
  }
</script>
